export default {"src":"/_next/static/media/editOnHoverPencil.52b8e8c2.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};